const { useEffect, useState } = require('react');
const { context } = require('app-context');
const { useAppSelector } = require('utils/redux');

exports.previewEnvironment = (env = process.env, hostname = typeof window === 'undefined' ? '' : window.location.hostname) =>
    (env.NODE_ENV === 'development' && env.NERPY_PREVIEW_ENABLED === 'true') ||
    (env.NERPY_STAGING_PILOT_ENABLED === 'true' && hostname === 'staging.nearpeer.net');

exports.previewViewer = (user, schoolId) => exports.previewEnvironment() && Number(schoolId) === 240394 &&
    [2, 12].includes(Number(user?.roleId)) && !!user?.id;

exports.useNerpy = () => {

    const user = useAppSelector(context.selectors.all.getCurrentUserObject);
    const schoolId = useAppSelector(context.selectors.all.getCurrentSchoolId);
    const scope = `${schoolId}:${user?.roleId}:${user?.id}`;
    const eligible = exports.previewViewer(user, schoolId);
    const [state, setState] = useState(null);
    const [revision, setRevision] = useState(0);

    useEffect(() => {

        const refresh = () => setRevision((value) => value + 1);
        window.addEventListener('nerpy-preferences-changed', refresh);
        return () => window.removeEventListener('nerpy-preferences-changed', refresh);
    }, []);

    useEffect(() => {

        let current = true;
        setState(null);

        if (eligible) {
            context.api.nearpeer.nerpy.availability().then((data) => {

                if (current) {
                    setState({ scope, assistant: data.enabled && data.preview ? data : null });
                }
            }).catch(() => { if (current) { setState({ scope, assistant: null }); } });
        }

        return () => { current = false; };
    }, [scope, eligible, revision]);

    return { scope, eligible, loading: eligible && state?.scope !== scope, assistant: eligible && state?.scope === scope ? state.assistant : null };
};
